import { defineComponent } from 'vue'
import AgGridColumnMethodMixins from '@/Mixins/SigmaClientNew/AgGridColumnMethods'
import { getSimpleDate } from '@/utils/helpers/FormatDate'

/*
* AG Grid Column Defs here
*/
export default defineComponent({
  mixins: [AgGridColumnMethodMixins],

  data () {
    return {
      nachaVendorGroupColumn: {
        headerName: 'Vendor',
        field: 'vendorGroup',
        colId: 'vendorGroup',
        maxWidth: 800,
        minWidth: 400,
        editable: false,
        sortable: true,
        rowGroup: true,
        hide: true,
        aggFunc: 'first',
        valueGetter: (params) => params.data && params.data.attributes && this.hasCompleteAchData(params.data.get('vendor')) ? params.data.get('vendor.name') : params.data.get('vendor.name') + ' (MISSING ACH INFO)',
        valueSetter: () => null
      },

      // Simulated Column
      nachaVendorColumn: {
        headerName: 'Vendor',
        field: 'vendor',
        colId: 'vendor',
        maxWidth: 300,
        minWidth: 200,
        editable: false,
        sortable: true,
        valueGetter: (params) => params.data && params.data.attributes ? params.data.attributes.vendor_name : '',
        valueSetter: () => null
      },

      // Simulated Column
      nachaAccountColumn: {
        headerName: 'Account',
        field: 'vendor_account_number',
        colId: 'vendor_account_number',
        maxWidth: 300,
        minWidth: 200,
        editable: false,
        sortable: true,
        valueGetter: (params) => params.data && params.data.attributes ? params.data.attributes.account : '',
        valueSetter: () => null
      },

      // Simulated Column
      nachaRoutingColumn: {
        headerName: 'Routing',
        field: 'vendor_routing_number',
        colId: 'vendor_routing_number',
        maxWidth: 300,
        minWidth: 200,
        editable: false,
        sortable: true,
        valueGetter: (params) => params.data && params.data.attributes ? params.data.attributes.routing : '',
        valueSetter: () => null
      },

      nachaNumberColumn: {
        headerName: 'PO Number',
        field: 'number',
        colId: 'number',
        maxWidth: 200,
        minWidth: 70,
        editable: false,
        sortable: true,
        valueGetter: (params) => params.data && params.data.attributes ? params.data.attributes.number : '',
        valueSetter: () => null
      },

      nachaDescriptionColumn: {
        headerName: 'PO Description',
        field: 'description',
        colId: 'description',
        maxWidth: 500,
        minWidth: 200,
        editable: false,
        sortable: true,
        valueGetter: (params) => params.data && params.data.attributes ? params.data.attributes.description : '',
        valueSetter: () => null
      },

      nachaAmountColumn: {
        headerName: 'PO Amount',
        field: 'amount_decimal',
        colId: 'amount_decimal',
        maxWidth: 150,
        minWidth: 100,
        editable: false,
        cellClass: 'amount',
        sortable: true,
        aggFunc: 'sum',
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => (params.data && params.data.attributes ? params.data.attributes.amount_decimal : ''),
        valueSetter: () => null
      },

      apVendorRoutingColumn: {
        headerName: 'Routing #',
        field: 'ach_routing_number',
        colId: 'ach_routing_number',
        maxWidth: 200,
        minWidth: 150,
        editable: false,
        sortable: true,
        hide: true,
        aggFunc: 'first',
        valueGetter: (params) => params.data && params.data.attributes ? params.data.get('vendor.ach_routing_number') : '',
        valueSetter: () => null
      },

      apVendorAccountColumn: {
        headerName: 'Account #',
        field: 'ach_account_number',
        colId: 'ach_account_number',
        maxWidth: 200,
        minWidth: 150,
        editable: false,
        sortable: true,
        hide: true,
        aggFunc: 'first',
        valueGetter: (params) => params.data && params.data.attributes ? params.data.get('vendor.ach_account_number') : '',
        valueSetter: () => null
      },

      apVendorColumn: {
        headerName: 'Vendor',
        field: 'vendor',
        colId: 'vendor',
        maxWidth: 300,
        minWidth: 200,
        editable: false,
        sortable: true,
        valueGetter: (params) => params.data && params.data.attributes ? params.data.get('vendor.name') : '',
        valueSetter: () => null
      },

      apBatchColumn: {
        headerName: 'Batch',
        field: 'batch',
        colId: 'batch',
        maxWidth: 200,
        minWidth: 70,
        editable: false,
        sortable: true,
        // rowGroup: true,
        valueGetter: (params) => {
          if (params.data && params.data.attributes && params.data.attributes.batch && params.data.get('batch').to) {
            return params.data.get('batch').to.cache && params.data.get('batch').to.cache[params.data.attributes.batch] ? params.data.get('batch').to.cache[params.data.attributes.batch].resource.attributes.name : ''
          } else {
            return params.data && params.data.attributes && params.data.attributes.batch && params.data.get('batch') ? params.data.get('batch.name') : ''
          }
        },
        valueSetter: () => null
      },

      apDescriptionColumn: {
        headerName: 'Description',
        field: 'description',
        colId: 'description',
        maxWidth: 500,
        minWidth: 200,
        editable: false,
        sortable: true,
        valueGetter: (params) => params.data && params.data.attributes ? params.data.attributes.description : '',
        valueSetter: () => null
      },

      apNumberColumn: {
        headerName: 'Invoice #',
        field: 'number',
        colId: 'number',
        maxWidth: 200,
        minWidth: 70,
        editable: false,
        sortable: true,
        checkboxSelection: (params) => {
          if (params.data && this.hasCompleteAchData(params.data.get('vendor'))) {
            return true
          } else if (params.node && params.node.allChildrenCount) {
            return params.node.allLeafChildren.every((child) => {
              return this.hasCompleteAchData(child.data.get('vendor'))
            })
          } else {
            return false
          }
        },
        headerCheckboxSelection: true,
        valueGetter: (params) => params.data && params.data.attributes ? params.data.attributes.number : '',
        valueSetter: () => null
      },

      apAmountColumn: {
        headerName: 'Inv Amount',
        field: 'amount_decimal',
        colId: 'amount_decimal',
        maxWidth: 150,
        minWidth: 100,
        editable: false,
        cellClass: 'amount',
        sortable: true,
        aggFunc: 'sum',
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => (params.data && params.data.attributes ? params.data.attributes.amount_decimal : ''),
        valueSetter: () => null
      },
      nachaSelectedAmountColumn: {
        headerName: 'Selected Amount',
        field: 'selected_amount_decimal',
        colId: 'selected_amount_decimal',
        maxWidth: 150,
        minWidth: 100,
        editable: false,
        cellClass: 'amount',
        sortable: true,
        aggFunc: 'sumSelected',
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => (params.data && params.data.attributes ? params.data.attributes.amount_decimal : ''),
        valueSetter: () => null
      },

      // Since we grouped ap transactions, need to save for each resource
      nachaPaymentNumberColumn: {
        headerName: 'Payment Conf. Number',
        field: 'payment_confirmation_number',
        colId: 'payment_confirmation_number',
        maxWidth: 200,
        minWidth: 150,
        sortable: false,
        menuTabs: ['columnsMenuTab'],
        editable: () => this.allowEdit,
        cellClass: () => this.allowEdit ? 'editable' : '',
        valueGetter: (params) => (params.data && params.data.attributes ? params.data.attributes.payment_confirmation_number : ''),
        valueSetter: (params) => {
          if (params.newValue && params.data.attributes && params.data.attributes.resources) {
            params.data.attributes.payment_confirmation_number = params.newValue
          }
        }
      },

      apPaymentNumberColumn: {
        headerName: 'Payment Conf. Number',
        field: 'payment_confirmation_number',
        colId: 'payment_confirmation_number',
        maxWidth: 200,
        minWidth: 150,
        sortable: false,
        menuTabs: ['columnsMenuTab'],
        rowGroup: true,
        editable: true,
        cellClass: 'editable',
        valueGetter: (params) => (params.data && params.data.attributes ? params.data.attributes.payment_confirmation_number : ''),
        valueSetter: (params) => {
          if (params.newValue && params.newValue !== '') {
            this.updateRows(params.data.id, { 'payment_confirmation_number': params.newValue, payment_confirmation_number_duplicate_accepted: true })
          }
        }
      },

      apVendorResource: {
        headerName: 'vendorResource',
        field: 'vendorResource',
        colId: 'vendorResource',
        maxWidth: 0,
        minWidth: 0,
        editable: false,
        sortable: true,
        hide: true, // should always be hidden
        aggFunc: 'first',
        valueGetter: (params) => params.data ? params.data.get('vendor') : null,
        valueSetter: () => null
      },

      // Simulated Column
      nachaVendorEmailColumn: {
        headerName: 'Vendor Email',
        field: 'email',
        colId: 'email',
        maxWidth: 300,
        minWidth: 200,
        editable: true,
        sortable: true,
        valueGetter: (params) => params.data && params.data.attributes ? params.data.attributes.email : '',
        valueSetter: (params) => {
          if (params.oldValue !== params.newValue) {
            params.data.attributes.email = params.newValue
            this.updateVendor(params.data.attributes.vendor, { email: params.newValue })
          }
        }
      },

      nachaCCEmailColumn: {
        headerName: 'CC Email',
        field: 'company_email',
        colId: 'company_email',
        maxWidth: 300,
        minWidth: 200,
        sortable: true,
        editable: (params) => {
          return this.gridApi.getRowNode(params.node.id).isSelected()
        },
        checkboxSelection: true,
        valueGetter: (params) => {
          return (params.data && params.data.attributes && params.data.attributes && params.data.attributes.resources.length)
          ? [...new Set(params.data.attributes.resources.map((resource) => resource.attributes.company_email))].join(', ') : ''
        },
        valueSetter: (params) => {
          if (params.oldValue !== params.newValue) {
            params.data.attributes.resources[0].attributes.company_email = params.newValue
            const isSelected = this.gridApi.getRowNode(params.node.id).isSelected()
            params.data.attributes['cc_mail'] = isSelected ? [...new Set(params.data.attributes.resources.map((resource) => resource.attributes.company_email))].join(', ') : ''
          }
        }
      },

      nachaVendorSelectColumn: {
        headerName: '',
        field: 'notify',
        colId: 'notify',
        maxWidth: 44,
        minWidth: 70,
        editable: true,
        sortable: false,
        hide: this.allowNotify,
        headerCheckboxSelection: true,
        checkboxSelection: true
      },

      nachaFileAttachementsColumn: {
        headerName: 'File Attachments',
        field: 'file_attachment',
        colId: 'file_attachment',
        maxWidth: 200,
        minWidth: 150,
        editable: true,
        sortable: false,
        checkboxSelection: true
      },

      apPaymentDateColumn: {
        headerName: 'Payment Date',
        field: 'payment_date',
        colId: 'payment_date',
        maxWidth: 200,
        minWidth: 150,
        editable: false,
        sortable: true,
        hide: true,
        aggFunc: 'first',
        valueGetter: (params) => ((params.data && params.data.attributes && params.data.payment_date) ? params.data.attributes.payment_date : getSimpleDate(new Date(), 'yyyy-mm-dd')),
        valueSetter: () => null
      },

      apPaymentCombineCheckColumn: {
        headerName: 'Combine',
        field: 'payment_combine_checks',
        colId: 'payment_combine_checks',
        maxWidth: 200,
        minWidth: 150,
        editable: true,
        cellRenderer: (params) => {
          if (!params.data) return null
          const checkbox = document.createElement('input')
          checkbox.type = 'checkbox'
          checkbox.checked = params.data ? params.data.attributes.payment_combine_checks : false
          checkbox.addEventListener('change', () => {
            this.updateRows(params.data.id, { 'payment_combine_checks': checkbox.checked })
          })
          return checkbox
        },
        valueGetter: () => null,
        valueSetter: () => null
      }
    }
  }
})
